function donationCal (donationItems: any[]) : number {
    let totalDonation: number = 0;
    if(donationItems.length > 0) {
        donationItems.map((item: any) => {
            totalDonation += parseInt(item.totalItemPrice);
        })
    }
    return totalDonation;
}

export { donationCal };